export default __webpack_public_path__ + "static/media/img-unauthorize.20b91eb9.svg";